import UserAdd from './containers/UserAddPageContainer'
import UserEdit from './containers/UserEditPageContainer'

export { UserAdd, UserEdit }
